


































































































import { Component } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import { Surface, Picture, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import BillingModel from '@/views/Models/BillingModel.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';

@Component({
  components: {
    Surface,
    Picture,
    Typography,
    FilledButton,
    CoinNetworkFeatureTag
  }
})
export default class LocationEmptyState extends BillingModel {
  get isMobileDevice() {
    return isMobile();
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get name() {
    return this.business.name;
  }

  onClickCTA() {
    this.onClickUpgrade({
      props: {
        welcomeCtaText: 'Explore Locations',
        origin: 'Empty State Locations',
        action: 'Acceptance'
      }
    });
  }
}
